export type StringKey =
    | "title" | "subtitle" | "mode"
    | "modeConsonants" | "modeVowels" | "modeMixed" | "hintsLabel" | "startGame"
    | "defaultPlayer" | "replay" | "reveal" | "settings" | "newGame"
    | "bingo" | "continue" | "statusReady" | "statusPending" | "statusNext" | "statusEmpty"
    | "gameTypePractice" | "gameTypeTogether" | "gameType" | "createRoom" | "joinRoom"
    | "onlineRole" | "moderatorName" | "moderatorPlays" | "createRoomBtn"
    | "roomCodeLabel" | "roomCodePlaceholder" | "joinName" | "joinBtn"
    | "yourRoom" | "shareLink" | "copyLink" | "linkCopied"
    | "waitingForPlayers" | "lobbyPlayerCount" | "startGameOnline" | "playersJoined"
    | "minPlayersNeeded" | "you" | "waitingForModerator" | "youJoinedAs"
    | "statusModeratorRandomizing" | "statusSelectYourCell" | "statusWaitingReveal"
    | "statusCharRevealed" | "readyBtn" | "readyStatus" | "playersReady" | "allReady"
    | "playerDisconnected" | "moderatorDisconnected" | "reconnecting"
    | "errorRoomNotFound" | "errorConnection" | "connecting"
    | "botPlayer" | "randomName" | "botCount" | "botsReady" | "allBotsReady"
    | "confirmLeaveRoom" | "confirmLeaveRoomPlayer" | "roomClosed";

export type StringMap = Record<StringKey, string>;

export const STRINGS: Record<string, StringMap> = {
    th: {
        title: 'บิงโกภาษาไทย',
        subtitle: 'เรียนรู้ตัวอักษรไทยแสนสนุก!',
        mode: 'โหมด',
        modeConsonants: 'พยัญชนะ',
        modeVowels: 'สระ',
        modeMixed: 'ผสม',
        hintsLabel: 'เปิดคำใบ้ (ช่องที่ตรงจะกระพริบ)',
        startGame: 'เริ่มเกม! 🎮',
        defaultPlayer: 'ผู้เล่น',
        replay: '🔊 ฟังอีกครั้ง',
        reveal: 'เฉลย',
        settings: '⚙️ ตั้งค่า',
        newGame: '🔄 เกมใหม่',
        bingo: '🎉 บิงโก! 🎉',
        continue: 'เล่นต่อ',
        statusReady: 'กดสุ่มเพื่อเริ่ม',
        statusPending: 'กด เฉลย เพื่อเปิด หรือ ฟังอีกครั้ง',
        statusNext: 'กดสุ่มเพื่อเรียกตัวถัดไป',
        statusEmpty: 'หมดตัวอักษรแล้ว',
        gameTypePractice: 'ฝึกฝน',
        gameTypeTogether: 'เล่นกับเพื่อน',
        gameType: 'ประเภทเกม',
        createRoom: 'สร้างห้อง',
        joinRoom: 'เข้าร่วม',
        onlineRole: 'บทบาท',
        moderatorName: 'ชื่อของคุณ',
        moderatorPlays: 'ฉันเล่นด้วย',
        createRoomBtn: 'สร้างห้อง',
        roomCodeLabel: 'รหัสห้อง',
        roomCodePlaceholder: 'เช่น A3BK7P',
        joinName: 'ชื่อของคุณ',
        joinBtn: 'เข้าร่วม',
        yourRoom: 'ห้องของคุณ',
        shareLink: 'แชร์ลิงก์',
        copyLink: 'คัดลอก',
        linkCopied: 'คัดลอกแล้ว!',
        waitingForPlayers: 'รอผู้เล่นเข้าร่วม...',
        lobbyPlayerCount: 'ผู้เล่น {n} คนเข้าร่วมแล้ว',
        startGameOnline: 'เริ่มเกม!',
        playersJoined: 'ผู้เล่น',
        minPlayersNeeded: 'ต้องมีผู้เล่นอย่างน้อย 1 คน',
        you: 'คุณ',
        waitingForModerator: 'รอผู้ดำเนินเกมเริ่ม...',
        youJoinedAs: 'คุณเข้าร่วมในชื่อ',
        statusModeratorRandomizing: 'ผู้ดำเนินเกมกำลังสุ่ม...',
        statusSelectYourCell: 'เลือกช่องของคุณ!',
        statusWaitingReveal: 'รอเฉลย...',
        statusCharRevealed: 'คำตอบคือ {char}',
        readyBtn: '🙋 พร้อมแล้ว!',
        readyStatus: 'พร้อม',
        playersReady: '{n}/{total} คนพร้อมแล้ว',
        allReady: 'ทุกคนพร้อมแล้ว!',
        playerDisconnected: 'หลุดการเชื่อมต่อ',
        moderatorDisconnected: 'ผู้ดำเนินเกมหลุดการเชื่อมต่อ',
        reconnecting: 'กำลังเชื่อมต่อใหม่...',
        errorRoomNotFound: 'ไม่พบห้อง',
        errorConnection: 'เชื่อมต่อไม่ได้',
        connecting: 'กำลังเชื่อมต่อ...',
        botPlayer: 'บอท',
        randomName: 'สุ่มชื่อ',
        botCount: 'จำนวนบอท',
        botsReady: '{n}/{total} บอทพร้อมแล้ว',
        allBotsReady: 'บอททุกตัวพร้อมแล้ว!',
        confirmLeaveRoom: 'ออกจากห้องหรือไม่? ผู้เล่นทุกคนจะถูกตัดการเชื่อมต่อ',
        confirmLeaveRoomPlayer: 'ออกจากห้องหรือไม่?',
        roomClosed: 'ผู้ดำเนินเกมปิดห้องแล้ว',
    },
    en: {
        title: 'Thai Alphabet Bingo',
        subtitle: 'Learn Thai letters through bingo!',
        mode: 'Mode',
        modeConsonants: 'Consonants',
        modeVowels: 'Vowels',
        modeMixed: 'Mixed',
        hintsLabel: 'Enable hints (matching cells pulse)',
        startGame: 'Start Game! 🎮',
        defaultPlayer: 'Player',
        replay: '🔊 Replay',
        reveal: 'Reveal',
        settings: '⚙️ Settings',
        newGame: '🔄 New Game',
        bingo: '🎉 Bingo! 🎉',
        continue: 'Continue',
        statusReady: 'Press randomize to start',
        statusPending: 'Press Reveal or Replay',
        statusNext: 'Press randomize for next',
        statusEmpty: 'No characters left',
        gameTypePractice: 'Practice',
        gameTypeTogether: 'Play Together',
        gameType: 'Game type',
        createRoom: 'Create Room',
        joinRoom: 'Join Room',
        onlineRole: 'Role',
        moderatorName: 'Your name',
        moderatorPlays: "I'm playing too",
        createRoomBtn: 'Create Room',
        roomCodeLabel: 'Room code',
        roomCodePlaceholder: 'e.g. A3BK7P',
        joinName: 'Your name',
        joinBtn: 'Join',
        yourRoom: 'Your room',
        shareLink: 'Share link',
        copyLink: 'Copy',
        linkCopied: 'Copied!',
        waitingForPlayers: 'Waiting for players...',
        lobbyPlayerCount: '{n} player(s) joined',
        startGameOnline: 'Start Game!',
        playersJoined: 'Players',
        minPlayersNeeded: 'Need at least 1 player',
        you: 'You',
        waitingForModerator: 'Waiting for moderator to start...',
        youJoinedAs: 'You joined as',
        statusModeratorRandomizing: 'Moderator is picking...',
        statusSelectYourCell: 'Select your cell!',
        statusWaitingReveal: 'Waiting for reveal...',
        statusCharRevealed: 'Answer: {char}',
        readyBtn: "🙋 I'm ready!",
        readyStatus: 'Ready',
        playersReady: '{n}/{total} ready',
        allReady: 'All players ready!',
        playerDisconnected: 'Disconnected',
        moderatorDisconnected: 'Moderator disconnected',
        reconnecting: 'Reconnecting...',
        errorRoomNotFound: 'Room not found',
        errorConnection: 'Connection failed',
        connecting: 'Connecting...',
        botPlayer: 'Bot',
        randomName: 'Random name',
        botCount: 'Number of bots',
        botsReady: '{n}/{total} bots ready',
        allBotsReady: 'All bots ready!',
        confirmLeaveRoom: 'Leave room? All players will be disconnected.',
        confirmLeaveRoomPlayer: 'Leave room?',
        roomClosed: 'The moderator has closed the room.',
    },
    ja: {
        title: 'タイ文字ビンゴ',
        subtitle: 'ビンゴでタイ文字を楽しく学ぼう！',
        mode: 'モード',
        modeConsonants: '子音',
        modeVowels: '母音',
        modeMixed: 'ミックス',
        hintsLabel: 'ヒントを有効にする（一致するマスが点滅）',
        startGame: 'ゲーム開始！ 🎮',
        defaultPlayer: 'プレイヤー',
        replay: '🔊 もう一度',
        reveal: '答え合わせ',
        settings: '⚙️ 設定',
        newGame: '🔄 新しいゲーム',
        bingo: '🎉 ビンゴ！ 🎉',
        continue: '続ける',
        statusReady: 'ランダムを押して開始',
        statusPending: '答え合わせ または もう一度 を押す',
        statusNext: 'ランダムを押して次へ',
        statusEmpty: '文字がありません',
        gameTypePractice: '練習',
        gameTypeTogether: 'みんなで遊ぶ',
        gameType: 'ゲームタイプ',
        createRoom: 'ルーム作成',
        joinRoom: '参加する',
        onlineRole: '役割',
        moderatorName: 'あなたの名前',
        moderatorPlays: '自分もプレイする',
        createRoomBtn: 'ルーム作成',
        roomCodeLabel: 'ルームコード',
        roomCodePlaceholder: '例: A3BK7P',
        joinName: 'あなたの名前',
        joinBtn: '参加',
        yourRoom: 'あなたのルーム',
        shareLink: 'リンクを共有',
        copyLink: 'コピー',
        linkCopied: 'コピーしました！',
        waitingForPlayers: 'プレイヤーを待っています...',
        lobbyPlayerCount: '{n}人が参加中',
        startGameOnline: 'ゲーム開始！',
        playersJoined: 'プレイヤー',
        minPlayersNeeded: '1人以上のプレイヤーが必要です',
        you: 'あなた',
        waitingForModerator: '司会者の開始を待っています...',
        youJoinedAs: '参加名',
        statusModeratorRandomizing: '司会者が選んでいます...',
        statusSelectYourCell: 'マスを選んでください！',
        statusWaitingReveal: '答え合わせを待っています...',
        statusCharRevealed: '答え：{char}',
        readyBtn: '🙋 準備OK！',
        readyStatus: '準備完了',
        playersReady: '{n}/{total}人が準備完了',
        allReady: '全員準備完了！',
        playerDisconnected: '切断されました',
        moderatorDisconnected: '司会者が切断されました',
        reconnecting: '再接続中...',
        errorRoomNotFound: 'ルームが見つかりません',
        errorConnection: '接続に失敗しました',
        connecting: '接続中...',
        botPlayer: 'ボット',
        randomName: 'ランダム名前',
        botCount: 'ボットの数',
        botsReady: '{n}/{total} ボットが準備完了',
        allBotsReady: '全ボット準備完了！',
        confirmLeaveRoom: 'ルームを退出しますか？全プレイヤーが切断されます。',
        confirmLeaveRoomPlayer: 'ルームを退出しますか？',
        roomClosed: '司会者がルームを閉じました。',
    }
};

export const LANGS = ['th', 'en', 'ja'];
export const LANG_LABELS: Record<string, string> = { th: '🇹🇭 TH', en: '🇬🇧 EN', ja: '🇯🇵 JA' };
